import React from 'react';
import { ChatProvider } from './ChatContext';
import ChatWidget from './ChatWidget';
import { featureFlags } from '@/config/featureFlags';

const BrickBot: React.FC = () => {
  if (!featureFlags.chatWidget) return null;

  return (
    <ChatProvider>
      <ChatWidget />
    </ChatProvider>
  );
};

export default BrickBot;
